import { useEffect } from "react";
import { AlertCircle, CheckCircle, X } from "lucide-react";

/**
 * Auto-dismissing alert banner.
 * @param {"error"|"success"} type
 * @param {string} message
 * @param {function} onClose
 * @param {string} screenSize
 * @param {object} fonts
 */
const Alert = ({ type, message, onClose, screenSize, fonts }) => {
  useEffect(() => {
    const timer = setTimeout(() => onClose(), 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      style={{
        position: "fixed",
        top: screenSize === "xs" ? "0.5rem" : "1.25rem",
        right: screenSize === "xs" ? "0.5rem" : "1.25rem",
        zIndex: 3000,
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
        padding: "0.75rem 1rem",
        borderRadius: "0.5rem",
        border: "1px solid",
        maxWidth: screenSize === "xs" ? "calc(100vw - 1rem)" : "25rem",
        backdropFilter: "blur(10px)",
        backgroundColor:
          type === "error"
            ? "rgba(239, 68, 68, 0.1)"
            : "rgba(34, 197, 94, 0.1)",
        borderColor: type === "error" ? "#ef4444" : "#22c55e",
        color: type === "error" ? "#ef4444" : "#22c55e",
      }}
    >
      {type === "error" ? (
        <AlertCircle size={16} />
      ) : (
        <CheckCircle size={16} />
      )}
      <span style={{ fontSize: fonts.body, flex: 1 }}>{message}</span>
      <button
        onClick={onClose}
        style={{
          background: "none",
          border: "none",
          color: "inherit",
          cursor: "pointer",
          padding: "0.25rem",
        }}
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default Alert;